/**
 * @owner @Appboy/whats-app
 */

// generated from 1_606 samples

import { z } from "zod";
import { common } from "../common";
import { stepGetBaseSchema } from "./stepGetBaseSchema";

export const facebookAudienceSyncStepGetSchema = z.object({
  ...stepGetBaseSchema.shape,
  type: z.literal("FACEBOOK_AUDIENCE_SYNC"),
  step_data: z.object({
    // null: 24 (1.49%)
    action: z
      .enum([
        "add_users", // 1_406 (88.87%)
        "remove_users", // 176 (11.13%)
      ])
      .nullable(),
    // null: 164 (10.21%)
    // format integer: 1_437 (99.65%)
    ad_account_id: z.string().nullable(),
    app_group_id: common.objectId,
    bulk_flusher_rate_limit_violation: z.literal(false),
    canvas_id: common.objectId,
    // null: 271 (16.87%)
    // format integer: 1_314 (98.43%)
    custom_audience_id: z.string().nullable(),
    // null: 29 (1.81%)
    custom_audience_name: z.string().nullable(),
    // null: 3 (0.19%)
    fields_to_match: z.array(z.string()).nullable(),
    // null: 406 (25.28%)
    intent: z
      .enum([
        "sync_to_existing", // 1_092 (91.00%)
        "create_new", // 108 (9.00%)
      ])
      .nullable(),
  }),
});
